import { Navigate } from 'react-router-dom';
import { obtenerSesion } from '../utils/sesion';

function RutaProtegida({ children }) {
  const sesion = obtenerSesion();
  if (!sesion?.token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export default RutaProtegida;
